import ReactDOM from "react-dom";
import { ModalInterface } from "../../helper/interface";

const Modal = ({ isOpen, children, size }: ModalInterface) => {
    if (!isOpen) return null;
    return ReactDOM.createPortal(
        <div className="modal overflow-y-auto show mt-0 ml-0 pl-0 z-10000 flex items-center" tabIndex={-1} aria-hidden="false">
            <div className={`modal-dialog modal-parent-div ${size ? `modal-${size}` : ""}`}>
                <div className="modal-content">
                    <div className="modal-body p-0">{children}</div>
                </div>
            </div>
        </div>,
        document.getElementById("modal") as HTMLElement
    );
};

export default Modal;
